import React from 'react';

const SIZE = {
  sm: { h: '32px', px: '14px', fs: 'var(--fs-body-sm)' },
  md: { h: '40px', px: '18px', fs: 'var(--fs-body-md)' },
  lg: { h: '46px', px: '22px', fs: 'var(--fs-body-lg)' },
};

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon = null,
  iconPosition = 'left',
  disabled = false,
  loading = false,
  fullWidth = false,
  type = 'button',
  onClick,
  ...rest
}) {
  const s = SIZE[size] || SIZE.md;
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    height: s.h,
    padding: `0 ${s.px}`,
    fontFamily: 'var(--font-body)',
    fontWeight: 600,
    fontSize: s.fs,
    borderRadius: 'var(--radius-pill)',
    border: '1px solid transparent',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.45 : 1,
    width: fullWidth ? '100%' : 'auto',
    transition: 'background var(--duration-fast) var(--ease-standard), box-shadow var(--duration-fast) var(--ease-standard), transform var(--duration-fast) var(--ease-standard)',
    whiteSpace: 'nowrap',
  };
  const variants = {
    primary: { background: 'var(--brand-primary)', color: 'var(--text-on-primary)' },
    secondary: { background: 'var(--surface-1)', color: 'var(--text-1)', border: '1px solid var(--border-strong)' },
    ghost: { background: 'transparent', color: 'var(--text-2)' },
    danger: { background: 'var(--status-danger-text)', color: '#fff' },
  };
  const cls = 'eq-btn eq-btn-' + variant;
  return (
    <button
      type={type}
      className={cls}
      style={{ ...base, ...variants[variant] }}
      disabled={disabled || loading}
      onClick={onClick}
      {...rest}
    >
      <style>{`
        .eq-btn-primary:hover:not(:disabled){background:var(--brand-primary-hover)}
        .eq-btn-primary:active:not(:disabled){background:var(--brand-primary-active);transform:scale(.98)}
        .eq-btn-secondary:hover:not(:disabled){background:var(--surface-2)}
        .eq-btn-secondary:active:not(:disabled){transform:scale(.98)}
        .eq-btn-ghost:hover:not(:disabled){background:var(--surface-2);color:var(--text-1)}
        .eq-btn-danger:hover:not(:disabled){background:var(--status-danger-text);filter:brightness(.92)}
        .eq-btn:focus-visible{box-shadow:var(--focus-ring-shadow)}
      `}</style>
      {loading ? (
        <span style={{ width: 14, height: 14, borderRadius: '50%', border: '2px solid currentColor', borderTopColor: 'transparent', animation: 'eq-spin .6s linear infinite' }} />
      ) : (
        icon && iconPosition === 'left' && icon
      )}
      {children}
      {!loading && icon && iconPosition === 'right' && icon}
      <style>{`@keyframes eq-spin{to{transform:rotate(360deg)}}`}</style>
    </button>
  );
}
